import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#internal-percentage" }),
  /*#__PURE__*/_createTextVNode(" Internal percentage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " In this case the percentage takes no additional space. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 26,
        percentage: 70,
        class: "mb-5"
      }),
      _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 24,
        percentage: 100,
        status: "success",
        class: "mb-5"
      }),
      _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 22,
        percentage: 80,
        status: "warning",
        class: "mb-5"
      }),
      _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 20,
        percentage: 50,
        status: "exception",
        class: "mb-5"
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}